import React from 'react';
import MainLayout from 'layouts/MainLayout';

import {Outlet} from 'react-router-dom';
import GenericViewSelector from 'components/navs/GenericViewSelector';
import {useUserProfileQuery} from "../../apis/authenticationApi";
import { subTaskMethod, editTaskMethod } from 'components/tasks/TaskComponent';
import TaskTable from "../../components/tables/TaskTable";
import {useSelector} from "react-redux";
import { useManageTeamTaskList } from 'hooks/taskHooks';
import KPITargetTable from 'pages/KPITarget/KPITargetTable';
import YearSelector from 'components/navs/YearSelector';
import { useTeamKpis } from 'hooks/kpiHooks';

const ManageTeamPage = () => {
    const {data: userProfile, isFetching} = useUserProfileQuery();
    const selectorName = "Manage Team Page";
    const dashboards = ["Team Tasks", "Team KPIs"];
    const selectedYear = useSelector(state => state.kpi.selectedYear);
    const selectedDashboard = useSelector(state => state.genericViewSelector.selectedDashboard?.[selectorName]) ?? dashboards?.[0] ?? "";
    const teamTasks = useManageTeamTaskList({deadlineYear: selectedYear});
    const teamKpis = useTeamKpis();
    
    return (
        <MainLayout>
            <div>
                <YearSelector />
                <GenericViewSelector views={dashboards} name={selectorName}/>
                {!isFetching && selectedDashboard === dashboards[0] &&
                    <TaskTable tasks={teamTasks}
                            newSubTaskEndpoint={subTaskMethod} 
                            editTaskEndpoint={['CompanyOwner','CompanyAdmin', 'CompanyManager'].includes(userProfile?.company?.role)? editTaskMethod : undefined}/>
                }
                {!isFetching && selectedDashboard === dashboards[1] &&
                     <>
                        <KPITargetTable predefinedKpis={teamKpis} predefinedSelectedView={2} hideNewButton={true} />
                    </>
                }
                <Outlet />
            </div>
        </MainLayout>
    )
}

export default ManageTeamPage;